import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router-dom";



export const SIMPLBreadcrumb = () => {

  const location = useLocation();
  const { t } = useTranslation();
  
  const paths = location.pathname.split("/").filter(Boolean);
const ROUTE_LABELS: Record<string, string> = {
  "script": t("Script"),
  "add-new": t("Add"),
  "vm-template": t("VmTemplate"),
  "management": t("Management"),
  "add-vm-template": t("AddVmTemplate"),
  "edit-vm-template": t("EditVmTemplate"),
  "cloud-provisioner-template":t("CloudProvisioner"),
  "cloud-environment":t("CloudEnvironment"),
  "add": t("AddNew"),
  "add-cloud": t("AddCloud"),
};
  return (
    <nav className="mb-4">
      <ol className="flex items-center text-sm">
        {/* Home */}
        <li>
          <NavLink
            to="/"
            className="text-[#B60F8D] hover:underline font-medium"
          >
            Home
          </NavLink>
        </li>

        {paths.map((path, index) => {
          const isLast = index === paths.length - 1;
          const to = `/${paths.slice(0, index + 1).join("/")}`;

          return (
            <li key={to} className="flex items-center">
              {/* Separator */}
              <span className="mx-2 text-gray-400">{">"}</span>

              {isLast ? (
                /* Last item (gray, not clickable) */
                <span className="text-gray-500 font-normal">
                  {ROUTE_LABELS[path] || path}
                </span>
              ) : (
                /* Middle items */
                <NavLink
                  to={to}
                  className="text-[#B60F8D] hover:underline font-medium"
                >
                  {ROUTE_LABELS[path] || path}
                </NavLink>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};